import { FC, memo } from 'react';

import {
  ContentBlock,
  ContentBlockProps,
} from '../../../ContentBlock.component';
import { useContentBlockRenderer } from './hooks/useContentBlockRenderer';
import { ContentBlockRendererProps } from './types/ContentBlockRendererProps';

const ContentBlockRendererComponent: FC<ContentBlockRendererProps> = ({
  displayWhen: _displayWhen,
  type: _type,
  description,
  heading,
  workflowDataResolverDependencies,
  ...props
}) => {
  const { evaluatedHeading, evaluatedDescription } = useContentBlockRenderer(
    description,
    heading,
    workflowDataResolverDependencies,
  );
  const contentBlockProps: ContentBlockProps = props;

  return (
    <ContentBlock
      {...contentBlockProps}
      description={evaluatedDescription}
      heading={evaluatedHeading}
    />
  );
};

export const ContentBlockRenderer = memo(ContentBlockRendererComponent);
